import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	providers: {
		loading: false,
		data: null,
	},
};

const networkManagementSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setProvidersData: (state, action) => {
			state.providers.data = action.payload;
		},
		setLoadingProviders: (state, action) => {
			state.providers.loading = action.payload;
		},
	},
});

export const { setProvidersData, setLoadingProviders } = networkManagementSlice.actions;
export default networkManagementSlice.reducer;
